// api.js

import axiosInstance from "../axiosInstance";

export const originZoneService = {
  create: async (zoneData) => {
    try {
      let response = await axiosInstance.post("/origin-zone", {
        ...zoneData,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, text) => {
    try {
      let query = `$limit=${limit || 15}&$skip=${skip || 0}`;
      if (text) {
        query += `&name[$search]=${text}`;
      }
      let response = await axiosInstance.get(`/origin-zone?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (zoneData, id) => {
    try {
      let response = await axiosInstance.patch(`/origin-zone/${id}`, {
        ...zoneData,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/origin-zone/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
